<template>
  <div>
    <div v-if="resource">
      <h1 class="content-title">{{ resource.title }}</h1>
      <hcm-video-detail-card
        v-if="itemType === 'VideoItem'"
        :resource="resource"
      ></hcm-video-detail-card>
      <hcm-audio-detail-card
        v-else-if="itemType === 'AudioItem'"
        :resource="resource"
      ></hcm-audio-detail-card>
      <hcm-text-detail-card
        v-else-if="itemType === 'TextItem'"
        :resource="resource"
      ></hcm-text-detail-card>
      <hcm-news-card
        v-else-if="itemType === 'NewsItem'"
        :resource="resource"
      ></hcm-news-card>
      <v-card v-else flat>
        <v-card-title>{{ resource.summary }}</v-card-title>
        <v-card-text v-html="resource.description"></v-card-text>
      </v-card>
    </div>
    <v-progress-circular v-else indeterminate></v-progress-circular>
  </div>
</template>

<script>
import { find } from "lodash";
import HCMVideoDetailCard from "../components/HCMVideoDetailCard.vue";
import HCMAudioDetailCard from "../components/HCMAudioDetailCard.vue";
import HCMTextDetailCard from "../components/HCMTextDetailCard.vue";
import HCMNewsCard from "../components/HCMNewsCard.vue";

export default {
  components: {
    "hcm-video-detail-card": HCMVideoDetailCard,
    "hcm-audio-detail-card": HCMAudioDetailCard,
    "hcm-text-detail-card": HCMTextDetailCard,
    "hcm-news-card": HCMNewsCard
  },
  data() {
    return {
      resource: null
    };
  },
  props: {
    itemType: {
      type: String,
      required: true
    },
    itemId: {
      type: String,
      required: true
    }
  },
  created() {
    console.log("detail");
    this.refreshData();
  },
  methods: {
    loadResource() {
      let r = find(this.$store.get(`resourceItems`), o => {
        return o.type === this.itemType && o.uuid === this.itemId;
      });

      if (r === undefined) {
        r = this.$store.get(`newsItems@${this.itemId}`);
      }

      this.resource = r;

      this.pageTrack(this.$router.currentRoute.path, this.resource.title);
    }
  },
  computed: {
    analyticsOn() {
      return this.$store.get("analyticsOn");
    }
  },
  watch: {
    refreshing: function(val) {
      if (!val) {
        this.loadResource();
      }
    },
    analyticsOn: function(val) {
      if (val) {
        this.pageTrack(this.$router.currentRoute.path, this.resource.title);
      }
    }
  }
};
</script>

<style scoped>
.content-title {
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
  font-weight: bold;
  font-size: 26px;
  padding-bottom: 10px;
  margin: 20px 0px;
  text-shadow: 0 1px 1px #5a6566;
}
</style>
